module.exports = __webpack_public_path__ + "static/img/4477_phase_function_Paper_Points.6b2d842.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/4477_phase_function_Paper_Points.png
// module id = I/Cr
// module chunks = 0